import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, MapPinIcon, StarIcon } from 'lucide-react';
interface Notification {
  firstName: string;
  lastName: string;
  province: string;
  timeAgo: string;
}
const NOTIFICATIONS: Notification[] = [{
  firstName: 'María',
  lastName: 'G.',
  province: 'Córdoba',
  timeAgo: '3 min'
}, {
  firstName: 'Juan',
  lastName: 'R.',
  province: 'Buenos Aires',
  timeAgo: '7 min'
}, {
  firstName: 'Lucía',
  lastName: 'F.',
  province: 'Rosario',
  timeAgo: '12 min'
}, {
  firstName: 'Carlos',
  lastName: 'M.',
  province: 'Mendoza',
  timeAgo: '15 min'
}, {
  firstName: 'Ana',
  lastName: 'L.',
  province: 'Tucumán',
  timeAgo: '18 min'
}, {
  firstName: 'Pablo',
  lastName: 'G.',
  province: 'Santa Fe',
  timeAgo: '22 min'
}, {
  firstName: 'Valentina',
  lastName: 'D.',
  province: 'La Plata',
  timeAgo: '25 min'
}, {
  firstName: 'Diego',
  lastName: 'S.',
  province: 'Salta',
  timeAgo: '30 min'
}, {
  firstName: 'Florencia',
  lastName: 'R.',
  province: 'Neuquén',
  timeAgo: '35 min'
}, {
  firstName: 'Martín',
  lastName: 'P.',
  province: 'Chaco',
  timeAgo: '40 min'
}];
export function SocialProofPopup() {
  const [currentNotification, setCurrentNotification] = useState<Notification | null>(null);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showRandomNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomNotification = () => {
    const randomIdx = Math.floor(Math.random() * NOTIFICATIONS.length);
    setCurrentNotification(NOTIFICATIONS[randomIdx]);
    setTimeout(() => {
      setCurrentNotification(null);
      const nextDelay = Math.floor(Math.random() * 3000) + 5000;
      setTimeout(showRandomNotification, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-210">
      {currentNotification && <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-[#0d1229] rounded-xl shadow-[0_0_25px_rgba(34,197,94,0.4)] border-2 border-[#22c55e] p-3 pr-5 max-w-[280px]" data-id="element-211">
          <div className="absolute -top-2.5 -right-2.5 flex items-center gap-1 bg-[#22c55e] text-white text-[10px] font-black px-2 py-1 rounded-full shadow-lg uppercase tracking-wider" data-id="element-212">
            <BadgeCheck className="w-3 h-3" data-id="element-213" />
            <span data-id="element-214">Verificado</span>
          </div>

          <div className="flex items-center gap-3" data-id="element-215">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#22c55e] to-green-700 flex items-center justify-center text-white text-sm font-black flex-shrink-0 shadow-sm border border-green-400" data-id="element-216">
              {currentNotification.firstName[0]}
              {currentNotification.lastName[0]}
            </div>

            <div className="min-w-0" data-id="element-217">
              <p className="text-sm font-bold text-white leading-tight truncate" data-id="element-218">
                {currentNotification.firstName} {currentNotification.lastName}
              </p>

              <div className="flex items-center gap-1.5 mt-1" data-id="element-219">
                <span className="flex items-center gap-px" data-id="element-220">
                  {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} className="w-3 h-3 text-yellow-400 fill-yellow-400" data-id="element-221" />)}
                </span>
                <span className="flex items-center gap-0.5 text-xs text-gray-300 font-semibold leading-tight" data-id="element-222">
                  <MapPinIcon className="w-3 h-3 flex-shrink-0 text-[#22c55e]" data-id="element-223" />
                  {currentNotification.province}
                </span>
              </div>

              <p className="text-[11px] text-[#22c55e] font-bold leading-tight mt-1" data-id="element-224">
                Compró el Kit de Hotelería · hace {currentNotification.timeAgo}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}